export default "__VITE_ASSET__Cjjdpjo2__"